import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-health"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      transform: "translate(-1551.859 -2165.77)",
      class: ""
    }, [
      _createElementVNode("path", {
        d: "M1584.9,2179.5c-2.4-2.4-6.2-2.4-8.5,0l0,0l-1.2,1.2l-1.2-1.2c-2.4-2.4-6.2-2.4-8.5,0\n\t\tc-1.3,1.3-1.9,3.1-1.7,4.9c0.1,1.4,0.7,2.7,1.7,3.7l1.2,1.2l0.5,0.5l8.1,8.1l8.5-8.5l1.2-1.2\n\t\tC1587.3,2185.7,1587.3,2181.9,1584.9,2179.5L1584.9,2179.5L1584.9,2179.5z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M1579.7,2186.9h-2.7l-2,4.1l-4-8.2l-2,4.1h-8.1",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }